import * as React from 'react';
import './Footer.css';

export default function Footer() {
    return (
        <div className="footer" position="static">
            <span>Copyright 2026 MLB Advanced Media, L.P.  Use of any content on this page acknowledges agreement to the terms posted here:&nbsp;<a href="http://gdx.mlb.com/components/copyright.txt">Terms</a></span>
        </div>
    );
}